import { LABEL } from "@/components/tool-kit/styles";
import type { ARRHENIUS_EQUATION_CALCULATOR_STRINGS } from "@/components/tools/arrhenius-equation-calculator";
import type { useToolNumber } from "@/components/tools/tool-ui";
import { MOLAR_ENERGY_UNITS } from "@/lib/tool-kit/chem-physical/gibbs";
import {
  unitFactor,
  unitOptionsOf,
  unitSymbol,
} from "@/lib/tool-kit/chem-physical/heat";
import { TEMPERATURE_UNITS } from "@/lib/tool-kit/chem-physical/units";
import { formatSig } from "@/lib/tool-kit/chemistry/format";

export type ArrheniusStrings = typeof ARRHENIUS_EQUATION_CALCULATOR_STRINGS;

export function arrheniusMessages(
  strings: ArrheniusStrings
): Record<string, string> {
  return {
    missing: strings.enterValues,
    unreadable: strings.errorUnreadable,
    nonPositive: strings.errorNonPositive,
    belowZero: strings.errorBelowZero,
    negativeEa: strings.errorNegativeEa,
    rateAboveA: strings.errorRateAboveA,
    sameTemperature: strings.errorSameTemperature,
    outOfRange: strings.errorOutOfRange,
    noTemperature: strings.errorNoTemperature,
    tooFewPoints: strings.errorTooFewPoints,
    badLine: strings.errorBadLine,
    allSameTemperature: strings.errorAllSameTemperature,
    zeroEa: strings.errorZeroEa,
  };
}

export const DEFAULT_SIG = 3;
export const R_TEXT = "8.314462618";
export const ENERGY_OPTIONS = unitOptionsOf(MOLAR_ENERGY_UNITS);
export const TEMPERATURE_OPTIONS = TEMPERATURE_UNITS.map((u) => ({
  value: u.id,
  label: u.symbol,
}));

export function eaText(
  fmt: ReturnType<typeof useToolNumber>,
  joules: number,
  unit: string,
  sig: number
): string {
  return `${formatSig(fmt, joules / unitFactor(MOLAR_ENERGY_UNITS, unit), sig)} ${unitSymbol(MOLAR_ENERGY_UNITS, unit)}`;
}

export function SolvedCell({
  label,
  text,
  id,
}: {
  label: string;
  text: string;
  id: string;
}) {
  return (
    <div className="space-y-2">
      <p className={LABEL} id={id}>
        {label}
      </p>
      <p className="rounded-md border border-primary/40 border-dashed bg-primary/5 px-3 py-2 text-foreground text-sm">
        {text}
      </p>
    </div>
  );
}
